import { render } from "./NavigationComponent.vue?vue&type=template&id=797ca85a&scoped=true"
import script from "./NavigationComponent.vue?vue&type=script&lang=js"
export * from "./NavigationComponent.vue?vue&type=script&lang=js"

import "./NavigationComponent.vue?vue&type=style&index=0&id=797ca85a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797ca85a"]])

export default __exports__